(function () {
  "use strict";

  if (window.ProductGallery) {
    window.ProductGallery.init(document);
    return;
  }

  function findAll(root, selector) {
    const matches = [];

    if (root instanceof Element && root.matches(selector)) {
      matches.push(root);
    }

    if (typeof root.querySelectorAll === "function") {
      matches.push(...root.querySelectorAll(selector));
    }

    return matches;
  }

  function initMobileSwipers(root) {
    const SwiperConstructor = typeof Swiper !== "undefined" ? Swiper : window.Swiper;
    if (typeof SwiperConstructor !== "function") return;

    findAll(root, ".product-mobile-swiper").forEach((swiperElement) => {
      const current = swiperElement.productGallerySwiper || swiperElement.swiper;
      if (current && !current.destroyed) return;

      const pagination = swiperElement.querySelector(".swiper-pagination");
      const slideCount = swiperElement.querySelectorAll(".swiper-slide").length;

      swiperElement.productGallerySwiper = new SwiperConstructor(swiperElement, {
        loop: slideCount > 1,
        autoHeight: true,
        observer: true,
        observeParents: true,
        pagination: pagination
          ? {
              el: pagination,
              clickable: true,
            }
          : undefined,
      });
    });
  }

  function initDesktopGalleries(root) {
    if (typeof window.IntersectionObserver === "undefined") return;

    findAll(root, ".product-desktop-gallery").forEach((gallery) => {
      if (gallery.productGalleryObserver) return;

      const images = Array.from(gallery.querySelectorAll(".product-large-image"));
      const menuItems = Array.from(gallery.querySelectorAll(".product-small-image"));
      if (!images.length || !menuItems.length) return;

      let previousScrollPosition = window.scrollY;

      function updateMarker(target) {
        if (!target.id) return;

        menuItems.forEach((item) => item.classList.remove("active"));
        const activeItem =
          menuItems.find((item) => item.getAttribute("href") === `#${target.id}`) || menuItems[0];
        activeItem.classList.add("active");
      }

      const observer = new window.IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const direction = window.scrollY > previousScrollPosition ? "down" : "up";
            previousScrollPosition = window.scrollY;
            const currentIndex = images.indexOf(entry.target);
            const target =
              direction === "down" && currentIndex < images.length - 1 ? images[currentIndex + 1] : entry.target;

            if ((direction === "down" && !entry.isIntersecting) || (direction === "up" && entry.isIntersecting)) {
              updateMarker(target);
            }
          });
        },
        { threshold: 0.3 },
      );

      updateMarker(images[0]);
      images.forEach((image) => observer.observe(image));
      gallery.productGalleryObserver = observer;
    });
  }

  function initYoutubePlayers(root) {
    const YoutubeConstructor = typeof LiteYTEmbedDiv !== "undefined" ? LiteYTEmbedDiv : window.LiteYTEmbedDiv;
    if (typeof YoutubeConstructor !== "function") return;

    findAll(root, ".product-gallery .lite-youtube, .product-desktop-gallery .lite-youtube").forEach((video) => {
      if (video.dataset.productGalleryYoutubeInitialized === "true") return;
      if (video.shadowRoot) {
        video.dataset.productGalleryYoutubeInitialized = "true";
        return;
      }
      new YoutubeConstructor(video);
      video.dataset.productGalleryYoutubeInitialized = "true";
    });
  }

  function initZoom(root) {
    findAll(root, ".product-mobile-swiper, .product-desktop-gallery").forEach((gallery) => {
      const links = Array.from(gallery.querySelectorAll(".product-media-zoom"));

      links.forEach((link) => {
        if (link.productGalleryZoomHandler) return;

        const handler = (event) => {
          const photoswipeElement = document.querySelector(".pswp");
          const PhotoSwipeConstructor = typeof PhotoSwipe !== "undefined" ? PhotoSwipe : window.PhotoSwipe;
          const PhotoSwipeUI =
            typeof PhotoSwipeUI_Default !== "undefined" ? PhotoSwipeUI_Default : window.PhotoSwipeUI_Default;
          if (!photoswipeElement || typeof PhotoSwipeConstructor !== "function" || typeof PhotoSwipeUI !== "function") {
            return;
          }

          event.preventDefault();
          const currentLinks = Array.from(gallery.querySelectorAll(".product-media-zoom"));
          const items = currentLinks.map((item) => ({
            src: item.getAttribute("href"),
            msrc: item.dataset.msrc,
            w: Number(item.dataset.w),
            h: Number(item.dataset.h),
          }));
          const index = currentLinks.indexOf(link);
          const photoswipe = new PhotoSwipeConstructor(
            photoswipeElement,
            PhotoSwipeUI,
            items,
            {
              index: index < 0 ? 0 : index,
              maxSpreadZoom: 2,
              loop: false,
              allowPanToNext: false,
              closeOnScroll: false,
              showHideOpacity: false,
              arrowKeys: true,
              history: false,
              fullscreenEl: false,
              zoomEl: false,
              shareEl: false,
              counterEl: true,
              arrowEl: true,
              preloaderEl: true,
            },
          );

          photoswipe.listen("parseVerticalMargin", (item) => {
            item.vGap = { top: 50, bottom: 50 };
          });
          photoswipe.init();
        };

        link.addEventListener("click", handler);
        link.productGalleryZoomHandler = handler;
      });
    });
  }

  function init(root = document) {
    initMobileSwipers(root);
    initDesktopGalleries(root);
    initYoutubePlayers(root);
    initZoom(root);
  }

  function destroy(root) {
    findAll(root, ".product-mobile-swiper").forEach((swiperElement) => {
      const instance = swiperElement.productGallerySwiper || swiperElement.swiper;
      if (instance && !instance.destroyed && typeof instance.destroy === "function") {
        instance.destroy(true, true);
      }
      delete swiperElement.productGallerySwiper;
    });

    findAll(root, ".product-desktop-gallery").forEach((gallery) => {
      if (gallery.productGalleryObserver) {
        gallery.productGalleryObserver.disconnect();
        delete gallery.productGalleryObserver;
      }
    });

    findAll(root, ".product-media-zoom").forEach((link) => {
      if (!link.productGalleryZoomHandler) return;
      link.removeEventListener("click", link.productGalleryZoomHandler);
      delete link.productGalleryZoomHandler;
    });
  }

  window.ProductGallery = { init, destroy };

  document.addEventListener("shopify:section:load", (event) => init(event.target));
  document.addEventListener("shopify:section:unload", (event) => destroy(event.target));

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(document), { once: true });
  } else {
    init(document);
  }
})();
